import { getDocumentCspNonce } from '@utils/cspNonce'

// Load the same single GTM container per document as before, even if a layout mounts more than once.
// The matching nonce authorizes the container; strict-dynamic trusts the scripts that container creates.
export function loadGtmScript(gtmId: string): Promise<HTMLScriptElement> {
  const existingScript = document.querySelector<HTMLScriptElement>('#gtm-script')
  if (existingScript) return Promise.resolve(existingScript)

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = 'gtm-script'
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`
    script.async = true
    script.nonce = getDocumentCspNonce()
    script.onload = () => resolve(script)
    script.onerror = () => {
      script.remove()
      reject(new Error('Error loading GTM script.'))
    }

    const taggedWindow = window as Window & { dataLayer?: object[] }
    if (!taggedWindow.dataLayer) taggedWindow.dataLayer = []
    taggedWindow.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
    document.head.appendChild(script)
  })
}
